import { mergeControls, removeFromInput, setupLayout, showErrorDialog, submitForm } from 'common.js';
import 'bootstrap-notify';
import 'jquery-components/bootstrap-datetimepicker';
import 'jquery-components/bootstrap-select';
import 'jquery-mask-plugin/dist/jquery.mask.min';
import $ from 'jquery.js';
import moment from 'moment';
import { ajaxGet, ajaxPost } from 'network/network-old.js';
// Boostrap modal требуется для showErrorDialog. FIXME: должно автоимпортироваться.
import { setupPopovers } from 'jquery-common/popovers';
import 'jquery-components/bootstrap-collapse';
import 'jquery-components/bootstrap-modal';
import 'jquery-components/bootstrap-validator';
import 'jquery-components/jquery-serialize-object';
import _ from 'lodash';
import { render, unmountComponentAtNode } from "react-dom";
import { appUrl, getCurrency, openPaymentUrl } from 'utils.ts';
import { formatString, _T } from '../../include/appI18n';
import { api, readCsrfToken } from '../../include/network/network';
import { PaymentFormContainer } from '../Payment/components/PaymentForm';
import { mapExtrasToJsonCompatibility } from '../TourSearch/store/utils';
import { tourDetailsUrl } from '../TourSearch/tour-urlgen';
import { CartTourConfiguratorContainer } from './components/CartTourConfigurator';
import { CartOrderContainer } from './components/CartOrder';

const TouristDocumentType = Object.freeze({
    RussianForeignPassport: 1,
    RussianPassport: 2,
    RussianBirthCertificate: 3,
    ForeignDocument: 4,
});

const BookingCustomerType = Object.freeze({
    Tourist: 0,
    Individual: 1,
    SoleProprietor: 2,
    Company: 3,
});

const foreignPassportId = { name: _T.COMMON_DOC_TYPE_FOREIGN_PASSWORD, value: TouristDocumentType.RussianForeignPassport, };
const russianId = { name: _T.COMMON_DOC_TYPE_PASSWORD_RF, value: TouristDocumentType.RussianPassport, };
const birthCert = { name: _T.COMMON_DOC_TYPE_BIRTH_CERT, value: TouristDocumentType.RussianBirthCertificate, };
const foreignDocumentId = { name: _T.COMMON_DOC_TYPE_FOREIGN_DOCUMENT, value: TouristDocumentType.ForeignDocument, };

const nameUppercaseSelector = '.tourist-form .form-group.surname input, ' +
    '.tourist-form .form-group.name input, ' +
    '.tourist-form .form-group.middlename input, ' +
    '#customer-surname, #customer-name, #customer-middlename';

function normalizeUppercaseInputs(selector) {
    $(selector).each(function () {
        const val = this.value;
        if (!val)
            return;
        const upper = val.toUpperCase();
        if (upper !== val)
            this.value = upper;
    });
}

function bindUppercaseNameInputs() {
    const selector = nameUppercaseSelector;
    $(document).off('input.uppercaseName', selector).on('input.uppercaseName', selector, function (e) {
        const el = e.target;
        const val = el.value;
        if (!val)
            return;
        const upper = val.toUpperCase();
        if (upper === val)
            return;
        const pos = el.selectionStart;
        el.value = upper;
        if (pos !== null && pos !== undefined && typeof el.setSelectionRange === 'function')
            el.setSelectionRange(pos, pos);
    });
    normalizeUppercaseInputs(selector);
}

const insurancePriceChangedMessage = 'Цена страховки изменилась';
const orderPriceChangedMessage = 'Стоимость заказа изменилась';
const transferPriceChangedNotificationsEnabled = true;

function getLegacyFieldClassName(field) {
    switch ((field || '').toLowerCase()) {
        case 'birthdate':
            return 'birthdate';
        case 'docexpirationdate':
            return 'docexpirationdate';
        case 'docdate':
            return 'docdate';
        case 'docnumber':
            return 'docnumber';
        case 'citizencountryid':
            return 'citizen-country-id';
        case 'doctype':
            return 'doctype';
        default:
            return field;
    }
}

function ensureFieldMessage($field) {
    let $message = $field.children('.error-msg');
    if (!$message.length) {
        $message = $('<div class="error-msg text-danger extra-small"></div>');
        $field.append($message);
    }

    return $message;
}

function setFieldMessage($field, message, isError = true) {
    if (!$field || !$field.length)
        return;

    const $message = ensureFieldMessage($field);
    $message.text(message || '');
    $field.toggleClass('error', !!message && isError);
}

function clearFieldMessage($field) {
    if (!$field || !$field.length)
        return;

    $field.removeClass('error');
    $field.children('.error-msg').text('');
}

function getBirthDateChangeIdentity(input) {
    const $input = $(input);
    const $form = $input.closest('.tourist-form');
    const $service = $input.closest('.arrived-info');
    const serviceId = Number.parseInt($service.data('serviceId'));
    const touristIdx = Number.parseInt($form.data('index'));
    if (!Number.isFinite(serviceId) || !Number.isFinite(touristIdx))
        return null;

    return { serviceId, touristIdx };
}

function findBirthDateInput(identity) {
    if (!identity)
        return $();

    return $(`.arrived-info[data-service-id="${identity.serviceId}"] .tourist-form[data-index="${identity.touristIdx}"] .form-group.birthdate input.birthdate`).first();
}

function setBirthDateMessage(identity, message) {
    const $input = findBirthDateInput(identity);
    if (!$input.length)
        return;

    setFieldMessage($input.closest('.form-group.birthdate'), message);
}

function clearBirthDateMessage(input) {
    const $input = $(input);
    clearFieldMessage($input.closest('.form-group.birthdate'));
    $input.closest('.row.tourist').removeClass('error');
}

function formatPriceDelta(delta, currency) {
    const value = Number(delta);
    if (!Number.isFinite(value) || value === 0)
        return '';

    const formatter = new Intl.NumberFormat(language || 'ru', {
        minimumFractionDigits: Math.abs(value) % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
    });
    return `${value > 0 ? '+' : '-'} ${formatter.format(Math.abs(value))} ${currency || ''}`.trim();
}

function hasCostDifference(response) {
    const value = Number(response?.costDifference);
    return Number.isFinite(value) && value !== 0;
}

function showOrderPriceChangedNotification(response) {
    if (!response?.priceChanged || !hasCostDifference(response))
        return;

    const delta = formatPriceDelta(response.costDifference, response.currency);
    $.notify(
        { message: delta ? `${orderPriceChangedMessage}<br>${delta}` : orderPriceChangedMessage },
        { type: 'warning', allow_dismiss: true, delay: 5000, z_index: 1200 }
    );
}

function readCartPriceChangedHeaders(response) {
    return {
        priceChanged: response?.headers?.get('X-Cart-Price-Changed') === 'true',
        costDifference: response?.headers?.get('X-Cart-Cost-Difference'),
        currency: response?.headers?.get('X-Cart-Currency'),
    };
}

function showTourUpdatePriceChangedNotification(response) {
    if (!transferPriceChangedNotificationsEnabled)
        return;

    showOrderPriceChangedNotification(readCartPriceChangedHeaders(response));
}

// Настройка страницы бронирования
/**
 * 
 * @param {import('./types').CartOrderProps} props
 */
function setupCart2(props) {
    const container = document.getElementById('cart-order-container');
    if (container) {
        moment.parseTwoDigitYear = function (yearString) {
            var year = parseInt(yearString);
            return year + (year > 30 ? 1900 : 2000);
        }

        window.__model = props;

        const root = CartOrderContainer({ ...props });
        render(root, container);
    }

    $(function () {
    });
}

// Настройка страницы бронирования
function setupCart(payEnabled, tourState, tourPriceExpired) {
    $(function () {
        Window.payEnabled = payEnabled;
        moment.parseTwoDigitYear = function (yearString) {
            var year = parseInt(yearString);
            return year + (year > 30 ? 1900 : 2000);
        }
        // Настройка полей выбора даты
        var dateOptions = {
            language: language,
            maxDate: new Date(),
            format: "DD.MM.YYYY",
            useCurrent: false,
            pickTime: false,
        };
        $(".input-group.date input.birthdate").datetimepicker(dateOptions);
        dateOptions.maxDate = undefined;
        dateOptions.minDate = new Date();
        $(".input-group.date input.docexpirationdate").datetimepicker(dateOptions);
        dateOptions.minDate = undefined;
        dateOptions.maxDate = new Date();
        $(".input-group.date input.docdate").datetimepicker(dateOptions);
        $(".input-group.date input").mask('0Z.0Z.00ZZ', {
            translation: {
                'Z': {
                    pattern: /[0-9]/,
                    optional: true
                },
            },
            selectOnFocus: true,
        })
        $(".input-group.date").on("dp.change", function (evt) {
            $(evt.target).data("DateTimePicker").hide();
        });

        setupCartDynamicBlocks();
        showHotelCompulsoryServicesDialogOnce();

        // Пересчет валюты
        $(document).on('currencychange', function (e) {
            e.preventDefault();

            const event = new CustomEvent('currencychange2', {
                cancelable: true,
                detail: { ...e.detail }
            });

            document.dispatchEvent(event)

            ajaxPost(appUrl("Cart/ReRenderCart"), { currencyId: e.originalEvent.detail.currencyID }, function (html) {
                mergeControls(html);
                setupCartDynamicBlocks();
            });

            window.currency = window.currencies.find(c => c.id == e.originalEvent.detail.currencyID);
        });

        // Удаление услуги
        $("a.delete-service").click(function (evt) {
            evt.preventDefault();
            var serviceId = $(this).attr("data-service-id");
            ajaxPost(appUrl("Cart/DeleteService"), { serviceId: serviceId }, function (html) {
                $(".service" + serviceId).remove();
                if ($("a.delete-service").length == 0) {
                    window.location.reload(true);
                } else {
                    mergeControls(html);

                    var tree = $.parseHTML(html);
                    var mapToParts = function (elts) { return elts.map(function (x) { return x.dataset.compsvcPart; }); };
                    var currentParts = mapToParts($('[data-compsvc-part]').get());
                    var newParts = new Set(mapToParts($('[data-compsvc-part]', tree).get()));
                    var danglingParts = currentParts.filter(function (x) { return !newParts.has(x) });
                    var danglingElts = danglingParts.flatMap(function (x) { return $('[data-compsvc-part="' + x + '"]').get(); });
                    $(danglingElts).remove();
                    setupCartDynamicBlocks();
                }
            });
        });

        $("a.change-tour").click(function (evt) {
            evt.preventDefault();
            let serviceId = $(this).attr("data-service-id");
            let tourId = $(this).attr("data-tour-id");
            let hash = $(this).attr("data-tour-hash");
            let fId = $(this).attr("data-tour-flight-id");
            let fpId = Number.parseInt($(this).attr("data-tour-flight-provider-id"));
            let separated = JSON.parse($(this).attr("data-tour-separated-flights") || "[]");
            window.location.href = tourDetailsUrl(tourId, { hash: hash, externalFlight: !fpId || !fId ? undefined : { flightId: fId, providerId: fpId }, separatedFlights: separated, useExtrasFromCart: true });
        });

        $(document).off('click.changeHotelCompulsoryService', 'a.change-hotel-compulsory-service')
            .on('click.changeHotelCompulsoryService', 'a.change-hotel-compulsory-service', function (evt) {
                evt.preventDefault();
                var info = getHotelCompulsoryServiceChangeInfo($(this));
                var infos = getHotelCompulsoryServiceChangeInfos();
                if (!infos.length)
                    infos = [info];
                showChangeHotelCompulsoryServicesModal(infos, info.serviceTag);
            });

        // Выбор фамилии из списка
        var hasOpenedMenu = false;
        var closeMenu = function () { $(".arrived-info .drop-mark .menu").remove(); hasOpenedMenu = false; };
        $(".surname .mark").click(function (evt) {
            evt.preventDefault();
            if (hasOpenedMenu && $(this).closest(".drop-mark").find(".menu").length)
                return;
            evt.stopPropagation();
            var $this = $(this);
            var parent = $this.closest(".drop-mark");
            var age = $this.closest(".row.tourist").attr("data-age");
            var thisForm = $this.closest("form")[0];
            closeMenu();
            // Проход по уже введённым туристам
            var tourists = [];
            $(".arrived-info .row.tourist[data-age='" + age + "'] form").each(function (idx, elt) {
                if (elt == thisForm) return;
                var t = $(elt).serializeObject();
                if (!t.surname) return;
                var fullDescr = (t.surname || "") + " " + (t.name || "");
                if (t.birthdate) fullDescr += ", " + t.birthdate;
                if (t.docnumber || t.docexpirationdate || t.docdate) fullDescr += " (" + t.docnumber + " " + (t.docexpirationdate ? t.docexpirationdate : t.docdate) + ")";
                t.fullDescr = fullDescr;
                for (var i = 0; i < tourists.length; i++)
                    if (tourists[i].fullDescr == t.fullDescr)
                        return;
                tourists.push(t);
            });
            if (tourists.length == 0)
                return;
            var menuNode = $("<div class='menu'></div>");
            for (var i = 0; i < tourists.length; i++) {
                var t = tourists[i];
                var item = $("<a></a>");
                item.text(t.fullDescr);
                (function (t) {
                    item.click(function () {
                        thisForm.gender.value = t.gender;
                        thisForm.surname.value = t.surname;
                        thisForm.name.value = t.name;
                        thisForm.birthdate.value = t.birthdate;
                        thisForm.docnumber.value = t.docnumber;
                        thisForm.docexpirationdate.value = t.docexpirationdate;
                        thisForm.docdate.value = t.docdate;
                        thisForm.doctype.value = t.doctype;
                        $(thisForm).find(".date input").each(function (idx, elt) {
                            $(elt).data("DateTimePicker").setValue($(elt).val());
                        });
                        closeMenu();
                        saveCartBookingInfo();
                    })
                })(t);
                menuNode.append(item);
            }
            parent.append(menuNode);
            hasOpenedMenu = true;
        });

        $('.citizen-country-id select').on('changed.bs.select', function (evt) {
            let select = $(evt.target).parents('.tourist').find('.citizen-country-id').find('select');
            let val = Number.parseInt(select.selectpicker('val'));
            let personId = select.data('personId');
            setupCitizenship(val, personId);
        });

        $('.birthdate input').on('change', function (evt) {
            let select = $(evt.target).parents('.tourist').find('.citizen-country-id').find('select');
            let val = Number.parseInt(select.selectpicker('val'));
            let personId = select.data('personId');
            setupCitizenship(val, personId);
        });
        $('.citizen-country-id select').each(function (idx, el) {
            let val = Number.parseInt($(el).selectpicker('val'));
            let personId = $(el).data('personId');
            setupCitizenship(val, personId);
        });

        $('.doctype select').on('changed.bs.select', function (evt) {
            let select = $(evt.target).parents('.tourist').find('.doctype').find('select');
            let val = Number.parseInt(select.selectpicker('val'));
            let personId = $(evt.target).data('personId');
            setupTouristDocument(val, personId);
        });
        $('.doctype select').each(function (idx, el) {
            let val = Number.parseInt($(el).selectpicker('val'));
            let personId = $(el).data('personId');
            setupTouristDocument(val, personId);
        });

        // Закрытие меню
        $(document).click(function (event) {
            if (!hasOpenedMenu || $(event.target).closest(".menu").length) return;
            closeMenu();
            event.stopPropagation();
        });

        // Детальная стоимость
        var detailedPriceParams = {
            html: true,
            container: document.getElementById('cart-section'),
            title: '<i class="fa fa-info" aria-hidden="true"></i><span>' + strings.booking.detailedPrice + '</span><button type="button" class="close">&times;</button>',
            content: function () {
                var node = $("#detailedPrice").clone();
                node.removeClass("dont-show collapse in");
                node.addClass("detailed-price");
                node.removeAttr("id");
                return node;
            }
        };
        setupPopovers(".top-detailed-price[data-toggle='popover'],.bottom-detailed-price[data-toggle='popover']", detailedPriceParams);

        // Условия оплаты и аннуляции (или только аннуляции в legacy-режиме)
        if (window.__showPaymentAndCancellationConditionsInConditionCol) {
            const payAndCancelConditionsParams = {
                html: true,
                title: '',
                customClass: 'p-0',
                content: function () {
                    const node = $('<div class="pay-and-cancel-conditions-popover-content"><div class="pay-and-cancel-conditions-loading-wrap"><span class="pay-and-cancel-conditions-spinner"></span><span class="pay-and-cancel-conditions-loading">' + (_T.COMMON_LOADING || '...') + '</span></div></div>');

                    const render = (data) => {
                        const formatDate = (value) => value ? moment(value).format('DD.MM.YYYY HH:mm') : '';
                        const formatAmount = (sum, currency) => sum === undefined || sum === null ? '' : `${Number(sum).toFixed(2)} ${currency || ''}`;
                        const rules = (data?.penaltyCalculationRules || []).slice().sort((a, b) => moment(a.From || a.from).valueOf() - moment(b.From || b.from).valueOf());
                        const prepaymentPercent = data?.booking?.prepaymentPercent ?? 25;
                        const prepaymentDate = formatDate(data?.booking?.prepaymentDate);
                        const paymentDate = formatDate(data?.booking?.paymentDate);

                        let html = '<div class="pay-and-cancel-conditions-section">';
                        html += '<div class="pay-and-cancel-conditions-title"><img src="' + appUrl('Content/img/dollar-symbol_x32.png') + '" alt="" /><span>' + _T.PAYMENT_CONDITIONS + '</span></div>';
                        html += '<div class="pay-and-cancel-conditions-grid">';
                        if (prepaymentPercent < 100 && prepaymentDate)
                            html += '<span>' + formatString(_T.BOOKING_PREPAY_PERCENT_BEFORE, [prepaymentPercent]) + ':</span><span class="pay-and-cancel-conditions-value">' + prepaymentDate + '</span>';
                        html += '<span>' + _T.BOOKING_FULL_PAY_BEFORE + ':</span><span class="pay-and-cancel-conditions-value">' + paymentDate + '</span></div></div>';

                        html += '<div class="pay-and-cancel-conditions-section">';
                        html += '<div class="pay-and-cancel-conditions-title"><img src="' + appUrl('Content/img/close_x32.png') + '" alt="" /><span>' + _T.CANCELLATION_CONDITIONS + '</span></div>';
                        html += '<div class="pay-and-cancel-conditions-grid pay-and-cancel-conditions-grid-head"><span>' + _T.BOOKING_CANCEL_PERIOD + '</span><span>' + _T.CANCELLATION_PENALTY + '</span></div>';
                        if (data?.cancellationDenied) {
                            html += '<div class="pay-and-cancel-conditions-empty">' + (_T.TOUR_SEARCH_NONREF_BADGE_TITLE || _T.CANCELLATION_CONDITIONS) + '</div>';
                        } else if (!rules.length) {
                            html += '<div class="pay-and-cancel-conditions-empty">' + _T.CANCELLATION_FREE + '</div>';
                        } else {
                            rules.forEach(rule => {
                                const fromStr = rule.FromString || rule.fromString || formatDate(rule.From || rule.from);
                                const sum = rule.Sum ?? rule.sum;
                                const currency = rule.Currency?.Name || rule.currency?.name;
                                html += '<div class="pay-and-cancel-conditions-grid"><span>' + (_T.CANCELLATION_FROM || '') + ' ' + fromStr + '</span><span class="pay-and-cancel-conditions-value">' + formatAmount(sum, currency) + '</span></div>';
                            });
                        }
                        html += '</div>';
                        node.html(html);
                    };

                    setTimeout(() => render(window.__paymentAndCancellationConditionsModel || {}), 0);

                    return node;
                },
            };
            setupPopovers(".info-btn.pay-and-cancel-conditions[data-toggle='popover']", payAndCancelConditionsParams);
        } else {
            var cancelConditionsParams = {
                html: true,
                title: '<i class="fa fa-info" aria-hidden="true"></i><span>' + strings.cancellation.bookingCancelTitle + '</span><button type="button" class="close">&times;</button>',
                content: function () {
                    var node = $("#cancellationConditions").clone();
                    node.removeClass("dont-show");
                    node.removeAttr("id");
                    return node;
                },
            };
            setupPopovers(".info-btn.cancel-conditions[data-toggle='popover']", cancelConditionsParams);
        }

        // Сохранение данных о туристах при уводе фокуса с полей ввода
        $(".container input,.container textarea").change(function () {
            // Валидация дат
            var dateObj = $(this).data("DateTimePicker");
            if (dateObj != null && $(this).val() && !dateObj.getDate()) $(this).val("");
            const isTouristBirthDate = $(this).hasClass('birthdate') && $(this).closest('.tourist-form').length;
            if ($(this).closest('.tourist-form').length)
                buildCustomerTouristOptions();
            if (isTouristBirthDate)
                saveCartBookingInfoAfterBirthDateChange(this);
            else
                saveCartBookingInfo();
        });
        $(".container .transfer .selectpicker, .arrived-info .selectpicker").on("changed.bs.select", function () {
            if ($(this).closest('.tourist-form').length)
                buildCustomerTouristOptions();
            saveCartBookingInfo();
        });

        // Запрет ввода неправильных символов в поля
        //removeFromInput($(".container .surname input,.container .name input,.container .middlename input"), /[^a-zа-яё \-]/gi, true);
        removeFromInput($(".container .date input"), /[^0-9.\/]/gi);
        //removeFromInput($(".container .docnumber input"), /[^0-9a-z \-]/gi);
        removeFromInput($(".container textarea"), /[<>]/gi);

        bindUppercaseNameInputs();

        $('.form-group.docnumber input').on('input', (e) => {
            //e.target.value = e.target.value?.toUpperCase();
            var val = $(e.target).val();
            var valNew = val?.toUpperCase();
            if (val != valNew) {
                var c = e.target.selectionStart;
                $(e.target).val(valNew);
                e.target.setSelectionRange(c, c);
                e.target.dispatchEvent(new Event('change', { target: e.target }));
            }
        })

        // Бронирование
        $("a.make-booking").click(function (evt) {
            evt.preventDefault();
            // if (!$("a.make-booking").attr('disabled'))
            cartMakeBooking();
        });

        $('.tourist-form input[name="gender"]').on('change', (e) => {
            let el = $(e.target);
            updateTourists(el.parents('.arrived-info').data('serviceId'), el.parents('.tourist-form').data('index'), el.attr('name'), el.parents('form').data('gender'));
            el.parents('form').data('gender', el.parents('form')[0].gender.value);
            //updateTourists(el.parents('.arrived-info').data('serviceId'), el.parents('.tourist-form').data('index'), el.attr('name'), el.data('prev'));
            //updateTourists(el.parents('.arrived-info').data('serviceId'), el.parents('.tourist-form').data('index'), el.attr('name'), ![...el.parents('form').find('[name="gender"]')].find(x => x.checked) ? '' : e.target.value == 'F' ? 'N' : 'F');
        });

        //$('.tourist-form input[name="gender"]').on('mousedown', (e) => {
        //    let el = $(e.target);
        //    el.data('prev', ![...el.parents('form').find('[name="gender"]')].find(x => x.checked) ? '' : e.target.value == 'F' ? 'N' : 'F');
        //});

        $('.tourist-form input:not([name="gender"])').on('blur', (e) => {
            let el = $(e.target);
            updateTourists(el.parents('.arrived-info').data('serviceId'), el.parents('.tourist-form').data('index'), el.attr('name'), el.data('prev'));
        });
        $('.tourist-form select').on('blur', (e) => {
            let el = $(e.target);
            updateTourists(el.parents('.arrived-info').data('serviceId'), el.parents('.tourist-form').data('index'), el.attr('name'), el.data('prev'));
        });

        $('.tourist-form input:not([name="gender"])').on('focus', (e) => {
            $(e.target).data('prev', e.target.value);
        });

        $('#healthCheckUrl').off('mouseup');
        $('#healthCheckUrl').on('mouseup', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $('#healthDeclarationDialog').modal();
        });

        $(document).on("click", function (e) {
            //if ($(e.target).is("a[href]") && e.button === 1) {
            if ($(e.target).is("#healthCheckUrl") && e.button === 1) {
                e.preventDefault();
            }
        });

        if (tourState || tourPriceExpired) {
            setTimeout(() => mounTourConfiguratorContainer(tourState, tourPriceExpired), 1000);
        }
    });
}

function setupCartExtended(payEnabled, tourState, tourPriceExpired) {
    setupCart(payEnabled, tourState, tourPriceExpired);
}

function getFallbackAttribute($primary, $fallback, name) {
    var value = $primary.attr(name);
    if (value === undefined && $fallback && $fallback.length)
        value = $fallback.attr(name);
    return value;
}

function getFallbackJsonAttribute($primary, $fallback, name, fallback) {
    var value = getFallbackAttribute($primary, $fallback, name);
    if (!value)
        return fallback;
    try {
        return JSON.parse(value);
    } catch (e) {
        return fallback;
    }
}

function getField(obj, pascalName, camelName) {
    if (!obj)
        return undefined;
    if (obj[pascalName] !== undefined)
        return obj[pascalName];
    return obj[camelName];
}

function getHotelCompulsoryServiceChangeInfo($source) {
    var $row = $source.hasClass('compulsory-services-body') ? $source : $source.closest('.compulsory-services-body');
    var $data = $row.length ? $row : $source;
    var $cells = $('td', $row);
    var $serviceCell = $cells.eq(2).clone();
    $serviceCell.find('a').remove();

    return {
        serviceTag: Number.parseInt(getFallbackAttribute($data, $source, 'data-service-tag')),
        hotelId: Number.parseInt(getFallbackAttribute($data, $source, 'data-hotel-id')),
        checkIn: getFallbackAttribute($data, $source, 'data-check-in'),
        checkOut: getFallbackAttribute($data, $source, 'data-check-out'),
        currencyId: Number.parseInt(getFallbackAttribute($data, $source, 'data-currency-id')),
        adults: Number.parseInt(getFallbackAttribute($data, $source, 'data-adults')) || 0,
        children: getFallbackJsonAttribute($data, $source, 'data-child-ages', []),
        services: getFallbackJsonAttribute($data, $source, 'data-services', []),
        currentId: Number.parseInt(getFallbackAttribute($data, $source, 'data-current-id')),
        currentClassId: Number.parseInt(getFallbackAttribute($data, $source, 'data-current-class-id')),
        currentDate: getFallbackAttribute($data, $source, 'data-current-date'),
        currentDuration: Number.parseInt(getFallbackAttribute($data, $source, 'data-current-duration')),
        currentName: $serviceCell.text().replace(/\s+/g, ' ').trim(),
        currentDateLabel: $cells.eq(1).text().trim(),
        currentPriceText: $cells.eq(3).text().trim(),
        personCountText: $cells.eq(4).text().trim(),
    };
}

function getHotelCompulsoryServiceChangeInfos() {
    return $('.hotel-order-table .compulsory-services-body').map(function () {
        var info = getHotelCompulsoryServiceChangeInfo($(this));
        if (!info.serviceTag || !info.hotelId || !Array.isArray(info.services) || info.services.length == 0)
            return null;
        return info;
    }).get();
}

function fetchCartCompulsoryServicePrices(info, callback) {
    if (!info || !info.hotelId || !Array.isArray(info.services) || info.services.length == 0) {
        callback(null);
        return;
    }

    var data = {
        hotelId: info.hotelId,
        currencyId: info.currencyId,
        checkIn: info.checkIn,
        checkOut: info.checkOut,
        'rooms[0].callerGeneratedId': 0,
        'rooms[0].quantity': 1,
        'rooms[0].adultBuyers': info.adults,
    };

    info.services.reduce(function (acc, service, i) {
        acc['services[' + i + '].id'] = getField(service, 'Id', 'id');
        acc['services[' + i + '].classId'] = getField(service, 'ClassId', 'classId');
        return acc;
    }, data);

    (info.children || []).reduce(function (acc, age, i) {
        acc['rooms[0].childBuyers[' + i + ']'] = age;
        return acc;
    }, data);

    ajaxGet(appUrl('/Hotel/GetCompulsoryServicePrices'), data, function (response) {
        var prices = getField(response, 'ServicePrices', 'servicePrices');
        if (!Array.isArray(prices)) {
            callback(null);
            return;
        }

        var choices = prices.map(function (price) {
            var id = getField(price, 'Id', 'id');
            var classId = getField(price, 'ClassId', 'classId');
            var service = info.services.find(function (x) {
                return getField(x, 'Id', 'id') == id && getField(x, 'ClassId', 'classId') == classId;
            });
            if (!service)
                return null;

            return {
                id: id,
                classId: classId,
                name: getField(service, 'Name', 'name'),
                validOn: getField(price, 'ValidOn', 'validOn'),
                validOnIso: getField(price, 'ValidOnIso', 'validOnIso'),
                duration: getField(price, 'Duration', 'duration'),
                price: getField(price, 'Price', 'price'),
                currency: getField(price, 'Currency', 'currency'),
            };
        }).filter(function (x) {
            return x !== null;
        });

        callback(choices);
    }, 'json');
}

function getChangeHotelCompulsoryServiceModal() {
    var $modal = $('#change-hotel-compulsory-service-modal');
    if ($modal.length)
        return $modal;

    $modal = $(
        '<div class="modal fade" id="change-hotel-compulsory-service-modal" tabindex="-1" role="dialog" aria-hidden="true">' +
        '   <div class="modal-dialog modal-lg" role="document">' +
        '       <div class="modal-content">' +
        '           <div class="modal-header">' +
        '               <button type="button" class="close" data-dismiss="modal" aria-label="Close">&times;</button>' +
        '               <h3 class="modal-title">Выбор обязательных доп. услуг</h3>' +
        '           </div>' +
        '           <div class="modal-body">' +
        '               <div class="hotel-compulsory-service-message">Условиями бронирования предусмотрены обязательные дополнительные услуги:</div>' +
        '               <div class="service-list-container"></div>' +
        '           </div>' +
        '           <div class="modal-footer">' +
        '               <button type="button" class="btn btn-default" style="color:#333" data-dismiss="modal">Закрыть</button>' +
        '               <button type="button" class="btn btn-orange confirm-change-hotel-compulsory-service" disabled>Сохранить</button>' +
        '           </div>' +
        '       </div>' +
        '   </div>' +
        '</div>'
    );
    $('body').append($modal);
    return $modal;
}

function formatCompulsoryServiceChoice(choice) {
    var parts = [];
    if (choice.validOn)
        parts.push(choice.validOn);
    if (choice.name)
        parts.push(choice.name);
    if (choice.priceText) {
        parts.push(choice.priceText);
    } else {
        var price = choice.price === undefined || choice.price === null ? '' : choice.price;
        var currency = choice.currency || '';
        if (price !== '' || currency)
            parts.push((price + ' ' + currency).trim());
    }
    return parts.join(' - ');
}

function getHotelCompulsoryServicesDialogKey($rows) {
    var version = $('#compulsory-services-table').attr('data-version');
    if (version)
        return 'cart-hotel-compulsory-services:' + version;

    return 'cart-hotel-compulsory-services:' + $rows.map(function () {
        return $(this).text().replace(/\s+/g, ' ').trim();
    }).get().join('|');
}

function isHotelCompulsoryServicesDialogSeen(key) {
    try {
        return sessionStorage.getItem(key) == '1';
    } catch {
        return false;
    }
}

function markHotelCompulsoryServicesDialogSeen(key) {
    try {
        sessionStorage.setItem(key, '1');
    } catch {
    }
}

function normalizeCompulsoryServiceDate(value) {
    if (!value)
        return '';
    var date = moment(value);
    if (date.isValid())
        return date.format('YYYY-MM-DD');
    return value.toString().substr(0, 10);
}

function getCompulsoryServiceChoiceKey(choice) {
    if (!choice)
        return '';
    return [
        choice.id === undefined || choice.id === null ? '' : choice.id,
        choice.classId === undefined || choice.classId === null ? '' : choice.classId,
        normalizeCompulsoryServiceDate(choice.validOnIso),
        choice.duration === undefined || choice.duration === null ? '' : choice.duration,
    ].join('|');
}

function getCurrentCompulsoryServiceChoice(info) {
    return {
        id: info.currentId,
        classId: info.currentClassId,
        name: info.currentName,
        validOn: info.currentDateLabel,
        validOnIso: info.currentDate,
        duration: info.currentDuration,
        priceText: info.currentPriceText,
    };
}

function getCompulsoryServiceSelectionIndex(info, choices) {
    var currentKey = getCompulsoryServiceChoiceKey(getCurrentCompulsoryServiceChoice(info));
    var index = choices.findIndex(function (choice) {
        return getCompulsoryServiceChoiceKey(choice) == currentKey;
    });
    if (index >= 0)
        return index;

    return choices.findIndex(function (choice) {
        return choice.id == info.currentId && choice.classId == info.currentClassId;
    });
}

function prepareCompulsoryServiceGroup(info, servicePrices) {
    var choices = (servicePrices || []).slice();
    var selectedIndex = getCompulsoryServiceSelectionIndex(info, choices);
    if (selectedIndex < 0) {
        choices.unshift(getCurrentCompulsoryServiceChoice(info));
        selectedIndex = 0;
    }

    return {
        info: info,
        servicePrices: choices,
        selectedIndex: selectedIndex,
        originalSelectionKey: getCompulsoryServiceChoiceKey(choices[selectedIndex]),
    };
}

function fetchCartCompulsoryServiceGroups(infos, callback) {
    if (!infos.length) {
        callback([]);
        return;
    }

    var groups = [];
    var remaining = infos.length;
    infos.forEach(function (info, index) {
        fetchCartCompulsoryServicePrices(info, function (servicePrices) {
            groups[index] = prepareCompulsoryServiceGroup(info, servicePrices);
            remaining--;
            if (remaining == 0)
                callback(groups.filter(function (x) { return !!x; }));
        });
    });
}

function getHotelCompulsoryServiceRadioName(group, index) {
    return 'change-hotel-compulsory-service-' + index + '-' + group.info.serviceTag;
}

function renderHotelCompulsoryServiceGroup($list, group, groupIndex, focusServiceTag, groupCount) {
    group.radioName = getHotelCompulsoryServiceRadioName(group, groupIndex);
    var info = group.info;
    var $group = $('<div />', {
        class: 'hotel-compulsory-service-group',
        'data-service-tag': info.serviceTag,
    });
    if (focusServiceTag && info.serviceTag == focusServiceTag)
        $group.addClass('active');

    if (groupCount > 1) {
        $('<h4 />').text(info.currentName || 'Обязательная услуга').appendTo($group);
        var details = [];
        if (info.currentDateLabel)
            details.push(info.currentDateLabel);
        if (info.currentPriceText)
            details.push(info.currentPriceText);
        if (info.personCountText)
            details.push(info.personCountText);
        if (details.length)
            $('<div />', { class: 'text-muted' }).text(details.join(' / ')).appendTo($group);
    }

    group.servicePrices.forEach(function (choice, index) {
        var radioId = group.radioName + '-' + index;
        var $radio = $('<input />', {
            type: 'radio',
            id: radioId,
            name: group.radioName,
            value: index,
        });
        if (index == group.selectedIndex)
            $radio.prop('checked', true);

        var $label = $('<label />', { for: radioId });
        $label.append($radio);
        $label.append(' ');
        $('<span />').text(formatCompulsoryServiceChoice(choice)).appendTo($label);
        $('<div />', { class: 'radio' }).append($label).appendTo($group);
    });

    if (groupIndex > 0)
        $('<hr />').appendTo($list);
    $list.append($group);
}

function getSelectedHotelCompulsoryServiceChanges(groups, $modal) {
    return groups.map(function (group) {
        var selectedIndex = Number.parseInt($('[name="' + group.radioName + '"]:checked', $modal).val());
        var selected = group.servicePrices[selectedIndex];
        if (!selected || getCompulsoryServiceChoiceKey(selected) == group.originalSelectionKey)
            return null;

        return {
            info: group.info,
            selected: selected,
        };
    }).filter(function (x) {
        return x !== null;
    });
}

function showChangeHotelCompulsoryServicesModal(infos, focusServiceTag) {
    var $modal = getChangeHotelCompulsoryServiceModal();
    var $list = $('.service-list-container', $modal).empty();
    var $confirm = $('.confirm-change-hotel-compulsory-service', $modal);
    $confirm.text('Сохранить').prop('disabled', true);
    $list.append($('<div />', { class: 'text-muted' }).text('Загрузка...'));
    $modal.modal();

    fetchCartCompulsoryServiceGroups(infos, function (groups) {
        $list.empty();
        if (!groups.length) {
            $list.append($('<div />', { class: 'text-muted' }).text('Нет доступных вариантов обязательной услуги'));
            return;
        }

        groups.forEach(function (group, index) {
            renderHotelCompulsoryServiceGroup($list, group, index, focusServiceTag, groups.length);
        });

        var toggleConfirm = function () {
            var hasMissingSelection = groups.some(function (group) {
                return $('[name="' + group.radioName + '"]:checked', $modal).length == 0;
            });
            $confirm.prop('disabled', hasMissingSelection);
        };

        $modal.off('change.changeHotelCompulsoryService', '.hotel-compulsory-service-group input[type="radio"]')
            .on('change.changeHotelCompulsoryService', '.hotel-compulsory-service-group input[type="radio"]', toggleConfirm);
        $confirm.off('click.changeHotelCompulsoryService').on('click.changeHotelCompulsoryService', function () {
            changeHotelCompulsoryServices(getSelectedHotelCompulsoryServiceChanges(groups, $modal), $modal);
        });
        toggleConfirm();
    });
}

function showHotelCompulsoryServicesDialogOnce() {
    var $rows = $('.hotel-order-table .compulsory-services-body');
    if (!$rows.length)
        return;

    var key = getHotelCompulsoryServicesDialogKey($rows);
    if (isHotelCompulsoryServicesDialogSeen(key))
        return;

    var infos = getHotelCompulsoryServiceChangeInfos();
    if (!infos.length)
        return;

    markHotelCompulsoryServicesDialogSeen(key);
    showChangeHotelCompulsoryServicesModal(infos);
}

function postHotelCompulsoryServiceChange(info, selected, callback, errorCallback) {
    ajaxPost(appUrl('/Cart/ChangeHotelCompulsoryService'), {
        serviceTag: info.serviceTag,
        id: selected.id,
        classId: selected.classId,
        serviceActivationDate: selected.validOnIso,
        serviceDuration: selected.duration,
    }, function (response) {
        var errors = getField(response, 'Errors', 'errors');
        if (Array.isArray(errors) && errors.length) {
            showErrorDialog(errors[0]);
            if (errorCallback)
                errorCallback();
            return;
        }

        callback(response);
    });
}

function changeHotelCompulsoryServices(changes, $modal) {
    if (!changes.length) {
        $modal.modal('hide');
        return;
    }

    var $confirm = $('.confirm-change-hotel-compulsory-service', $modal);
    $confirm.text('Сохранение...').prop('disabled', true);
    var index = 0;
    var lastResponse = null;
    var postNext = function () {
        var change = changes[index];
        postHotelCompulsoryServiceChange(change.info, change.selected, function (response) {
            lastResponse = response;
            index++;
            if (index < changes.length) {
                postNext();
                return;
            }

            $modal.modal('hide');
            mergeControls(lastResponse);
            setupCartDynamicBlocks();
            $confirm.text('Сохранить').prop('disabled', false);
        }, function () {
            $confirm.text('Сохранить').prop('disabled', false);
        });
    };
    postNext();
}

function getRealAge(age, personId, date) {
    const q = toJsonDate($('.tourist-' + personId + ' .form-group.birthdate input'));
    if (!q)
        return age;

    let birthday = moment(q);
    let baseDate = moment(date);
    if (!birthday.isValid() || !baseDate.isValid())
        return age;

    return Math.floor((baseDate.format('YYYYMMDD') - birthday.format('YYYYMMDD')) / 10000);
}

function setupCitizenship(val, personId) {
    const citizenCountryId = Number.parseInt($('.tourist-' + personId + ' .form-group.citizen-country-id select').selectpicker('val'));
    if (!citizenCountryId)
        return;

    const t = $('.tourist-' + personId);
    let age = Number.parseInt(t.data('age'));
    if (age < 0)
        age = 18;

    const realAge = getRealAge(age, personId);

    const serviceIsInternal = Number.parseInt(t.data('serviceIsInternal'));
    const serviceIsRuInternal = Number.parseInt(t.data('serviceIsRuInternal'));
    let useRussianDocuments = (serviceIsInternal && age >= 14) || serviceIsRuInternal;
    let isRussian = false;

    /**
     * @type {import('../../include/api-ito/common-types/ItoRecord').ItoRecord[]}
     */
    const citizenshipList = window.__citizenshipList;

    if (citizenCountryId && citizenshipList) {
        const citizenship = citizenshipList.find(function (x) { return x.id == citizenCountryId });
        if (citizenship) {
            useRussianDocuments = useRussianDocuments && citizenship.id == window.__russiaId;
            isRussian = citizenship.id == window.__russiaId;
        }
    }

    const docTypes = getDocTypes(useRussianDocuments, isRussian, age, realAge);
    const docTypeSelect = $('.tourist-' + personId + ' .form-group.doctype select');
    const docTypeInput = $('.tourist-' + personId + ' .form-group.doctype input');
    docTypeSelect.children('option').remove();
    docTypes.forEach(dt => {
        const option = document.createElement('option');
        option.value = dt.value;
        option.text = dt.name;
        docTypeSelect.append(option);
    });
    docTypeSelect.selectpicker('refresh');
    if (docTypes.length == 1) {
        docTypeSelect.parent().hide();
        docTypeInput.val(docTypes[0].name).show();
    } else {
        docTypeInput.val('').hide();
        docTypeSelect.parent().show();
    }
    docTypeSelect.trigger('change');
}

function getDocTypes(useRussianDocuments, isRussian, age, realAge) {
    if (useRussianDocuments) {
        if (age < 14) {
            return [birthCert, foreignPassportId];
        } else {
            if (realAge < 14)
                return [russianId, foreignPassportId, birthCert];
            else
                return [russianId, foreignPassportId];
        }
    } else {
        return [isRussian ? foreignPassportId : foreignDocumentId];
    }
}

function setDocumentRequiredLabel(personId, config) {
    let requiredSignNumber = $('.tourist-' + personId + ' .form-group.docnumber label .required-sign');
    let requiredSignDate = $('.tourist-' + personId + ' .form-group.docdate label .required-sign');
    let requiredSignDateExp = $('.tourist-' + personId + ' .form-group.docexpirationdate label .required-sign');
    if (config.serial)
        requiredSignNumber.hide();
    else
        requiredSignNumber.show();

    if (config.date) {
        requiredSignDate.hide();
        requiredSignDateExp.hide();
    }
    else {
        requiredSignDate.show();
        requiredSignDateExp.show();
    }
}

function applyNameValidation(personId, doctype) {
    // выбираем все нужные поля
    const $inputs = $('.tourist-' + personId + ' .form-group.surname input, ' +
        '.tourist-' + personId + ' .form-group.name input, ' +
        '.tourist-' + personId + ' .form-group.middlename input');

    // правила
    let regex, errorMsg;
    if (doctype == TouristDocumentType.RussianForeignPassport) { // Загранпаспорт
        regex = /^[A-Za-z \-]+$/;
        errorMsg = "Только латинские символы";
    } else { // Иностранный документ и прочие
        regex = /^[A-Za-zА-Яа-яЁё \-]+$/;
        errorMsg = "Только латинские и русские символы";
    }

    $inputs.off('.validateName'); // снимаем прошлые обработчики (чтобы не дублировались)
    $inputs.on('input.validateName blur.validateName', function () {
        const $field = $(this);
        const $fieldParent = $field.parents('.form-group');
        const val = $field.val();

        if (val === "" || regex.test(val)) {
            $fieldParent.removeClass('error');
            //$field.next('.error-msg').remove();
            $fieldParent.children('.error-msg').text('');
        } else {
            if (!$fieldParent.hasClass('error')) {
                $fieldParent.addClass('error');
                $fieldParent.children('.error-msg').text(errorMsg);
                //if (!$field.next('.error-msg'))
                //    $field.after('<div class="error-msg text-danger extra-small">' + errorMsg + '</div>');
            }
        }
    });

    //$inputs.trigger('input');
    $inputs.each((i, el) => {
        const $field = $(el);
        const val = $field.val();

        if (val === "" || regex.test(val)) {
            $field.removeClass('is-invalid');
            $field.next('.error-msg').remove();
        } else {
            if (!$field.hasClass('is-invalid')) {
                $field.addClass('is-invalid');
                $field.after('<div class="error-msg text-danger small">' + errorMsg + '</div>');
            }
        }
    })
}

function setupTouristDocument(val, personId) {
    applyNameValidation(personId, val);
    switch (val) {
        case TouristDocumentType.RussianForeignPassport:
            //$('.tourist-' + personId + ' .form-group.docexpirationdate > label').text(_T.COMMON_EXP_DATE);
            //$('.tourist-' + personId + ' .form-group.docnumber').parent().removeClass('col-md-6').addClass('col-md-3');
            $('.tourist-' + personId + ' .form-group.docdate').hide();
            $('.tourist-' + personId + ' .form-group.docexpirationdate').show();
            $('.tourist-' + personId + ' .form-group.docnumber input').prop('maxlength', 9);
            $('.tourist-' + personId + ' .form-group.docnumber input').prop('minlength', 9);
            $('.tourist-' + personId + ' .form-group.docnumber input').unmask();
            $('.tourist-' + personId + ' .form-group.docnumber input').mask('000000000', { selectOnFocus: false, });

            setDocumentRequiredLabel(personId, window.__optionalTouristFieldsConfig.foreignPassport);
            break;
        case TouristDocumentType.RussianPassport:
            //$('.tourist-' + personId + ' .form-group.docexpirationdate > label').text(_T.COMMON_DATE);
            //$('.tourist-' + personId + ' .form-group.docnumber').parent().removeClass('col-md-6').addClass('col-md-3');
            $('.tourist-' + personId + ' .form-group.docdate').show();
            $('.tourist-' + personId + ' .form-group.docexpirationdate').hide();
            $('.tourist-' + personId + ' .form-group.docnumber input').prop('maxlength', 10);
            $('.tourist-' + personId + ' .form-group.docnumber input').prop('minlength', 10);
            $('.tourist-' + personId + ' .form-group.docnumber input').unmask();
            $('.tourist-' + personId + ' .form-group.docnumber input').mask('0000000000', { selectOnFocus: false, });

            setDocumentRequiredLabel(personId, window.__optionalTouristFieldsConfig.russianPassport);
            break;
        case TouristDocumentType.RussianBirthCertificate:
            //$('.tourist-' + personId + ' .form-group.docexpirationdate > label').text(_T.COMMON_DATE);
            //$('.tourist-' + personId + ' .form-group.docnumber').parent().removeClass('col-md-6').addClass('col-md-3');
            $('.tourist-' + personId + ' .form-group.docdate').show();
            $('.tourist-' + personId + ' .form-group.docexpirationdate').hide();
            $('.tourist-' + personId + ' .form-group.docnumber input').prop('maxlength', 12);
            $('.tourist-' + personId + ' .form-group.docnumber input').unmask();
            if (window.__BirthCertStrictValidation) {
                $('.tourist-' + personId + ' .form-group.docnumber input').mask('RrrCC000000', {
                    translation: {
                        'r': {
                            pattern: /[XVIxvi]/,
                            optional: true
                        },
                        'R': {
                            pattern: /[XVIxvi]/
                        },
                        'C': {
                            pattern: /[А-Яа-яЁё]/
                        },
                    },
                    selectOnFocus: false,
                });
            } else {
                $('.tourist-' + personId + ' .form-group.docnumber input').mask('RRRRRRRRRrrrrrr', {
                    translation: {
                        'R': {
                            pattern: /[А-Яа-яЁёA-Za-z0-9\-]/,
                            optional: false
                        },
                        'r': {
                            pattern: /[А-Яа-яЁёA-Za-z0-9\-]/,
                            optional: true
                        },
                    },
                    selectOnFocus: false,
                });
            }

            setDocumentRequiredLabel(personId, window.__optionalTouristFieldsConfig.birthCertificate);
            break;
        case TouristDocumentType.ForeignDocument:
            //$('.tourist-' + personId + ' .form-group.docexpirationdate > label').text(_T.COMMON_DATE);
            //$('.tourist-' + personId + ' .form-group.docnumber').parent().removeClass('col-md-3').addClass('col-md-6');
            $('.tourist-' + personId + ' .form-group.docdate').hide();
            $('.tourist-' + personId + ' .form-group.docexpirationdate').show();
            $('.tourist-' + personId + ' .form-group.docnumber input').prop('maxlength', 20);
            $('.tourist-' + personId + ' .form-group.docnumber input').unmask();
            $('.tourist-' + personId + ' .form-group.docnumber input').mask('rrrrrrrrrrrrrrrrrrrr', {
                translation: {
                    'r': {
                        pattern: /[A-Za-z0-9]/,
                        optional: true
                    },
                },
                selectOnFocus: false,
            });

            setDocumentRequiredLabel(personId, window.__optionalTouristFieldsConfig.foreignDocument);
            break;
    }
}

function touristHash(serviceId, touristIndex, fieldName, oldValue) {
    var form = $(`.arrived-info[data-service-id="${serviceId}"] .tourist-form[data-index="${touristIndex}"]`)[0];
    if (!form)
        return undefined;

    function fieldValue(f, name, name2, oldValue) {
        if (name == name2)
            return oldValue ?? '';

        return f.elements.namedItem(name)?.value ?? '';
    }

    return `${fieldValue(form, 'gender', fieldName, oldValue)}::${fieldValue(form, 'surname', fieldName, oldValue)}::${fieldValue(form, 'name', fieldName, oldValue)}::${fieldValue(form, 'birthdate', fieldName, oldValue)}::${fieldValue(form, 'doctype', fieldName, oldValue)}::${fieldValue(form, 'docnumber', fieldName, oldValue)}::${fieldValue(form, 'docexpirationdate', fieldName, oldValue)}::${fieldValue(form, 'docdate', fieldName, oldValue)}::${fieldValue(form, 'citizenCountryId', fieldName, oldValue)}`;
}

function updateTourists(currentServiceId, touristIndex, fieldName, oldValue) {
    let forms = $('.tourist-form');
    let groups = _.groupBy([...forms], x => $(x).parents('.arrived-info').data('serviceId'));

    let currentTourists = groups[currentServiceId];
    let currentTourist = currentTourists[touristIndex];
    if (currentTourist[fieldName] && currentTourist[fieldName].value)
        $(currentTourist[fieldName]).parent('.form-group').removeClass('error');

    for (let serviceId in groups) {
        if (serviceId == currentServiceId)
            continue;

        let tourists = groups[serviceId];
        if (tourists.length != currentTourists.length)
            continue;

        if (tourists.find((v, i) => $(v).parents('.tourist').data('age') != $(currentTourists[i]).parents('.tourist').data('age')))
            continue;
        //for (let i = 0; i < tourists.length; i++) {
        //    if ($(tourists[i]).parent('.tourist').data('age') !== $(currentTourists[i]).parent('.tourist').data('age'))
        //        return;
        //}

        let tourist = tourists[touristIndex];
        //if (!tourist[fieldName].value || tourist[fieldName].value == oldValue)
        let hash = touristHash(serviceId, touristIndex);
        let currentHash = touristHash(currentServiceId, touristIndex, fieldName, oldValue);
        if (hash == currentHash) {
            $(tourist[fieldName]).removeClass('error');
            tourist[fieldName].value = currentTourist[fieldName].value;
            $(tourist).find(".date input").each(function (idx, elt) {
                $(elt).data("DateTimePicker").setValue($(elt).val());
            });
        }
    }


    //const booking = getCartBookingInfo();
    //if (!booking.services.length)
    //    return;

    //validateCart(booking, null, (r) => showCartBookingErrors(r, true));
}

function setupBookingSuccess() {
    $(document).on("click", ".do-payment", function (evt) {
        var amount = $('#pay-type-form').prop('pay-amount')?.value ?? $(evt.target).attr("data-amount");
        if (amount > 0)
            pay($(evt.target).attr("data-id"), amount);
        else
            location = $(evt.target).attr("data-booking-url") ?? "/";
    });
    $(document).on("change", "#prepay-input", prepayAmountChanged);
    $(document).on("blur", "#prepay-input", prepayAmountChanged);
    $(document).on("click", "#prepay-edit-button", function (ent) {
        $('#prepay-input').show();
        $('#prepay-edit-button').hide();
        $('#prepay-text').hide();
    });
}


// Преобразование даты в формат для разбора сервером
function toJsonDate(elt) {
    if (!elt || !elt.val()) return null;
    var d = elt.data("DateTimePicker").getDate();
    if (!d) return null;
    return d.format('YYYY-MM-DD');
}

function buildCustomerTouristOptions() {
    const $select = $('#customer-type');
    if (!$select.length)
        return;

    const previous = $select.val();
    $select.find('option[data-customer-option="tourist"]').remove();
    const $insertBefore = $select.find('option[data-customer-option="type"]').first();

    const appendOption = (option) => {
        if ($insertBefore.length)
            option.insertBefore($insertBefore);
        else
            $select.append(option);
    };

    const seen = new Set();
    $('.arrived-info .tourist-form').each(function () {
        const $form = $(this);
        const serviceId = $form.parents('.arrived-info').data('serviceId');
        const idx = $form.data('index');
        const hash = touristHash(serviceId, idx);
        if (!hash || seen.has(hash))
            return;
        seen.add(hash);

        const surname = ($form[0].surname?.value || '').trim();
        const name = ($form[0].name?.value || '').trim();
        const birth = ($form[0].birthdate?.value || '').trim();
        let label = `${surname} ${name}`.trim();
        if (birth)
            label = `${label} (${birth})`;
        if (!label && !birth)
            return;
        const option = $('<option></option>');
        option.attr('data-customer-option', 'tourist');
        option.val(`tourist:${serviceId}:${idx}`);
        option.text(label || option.val());
        if (previous === option.val())
            option.prop('selected', true);
        appendOption(option);
    });

    if (!$select.find('option[data-customer-option="tourist"]').length) {
        const defAdults = Number.parseInt($select.data('defaultAdults')) || 0;
        const defService = $select.data('defaultService');
        if (defAdults > 0 && defService) {
            for (let i = 0; i < defAdults; i++) {
                const option = $('<option></option>');
                option.attr('data-customer-option', 'tourist');
                option.val(`tourist:${defService}:${i}`);
                option.text(`Турист ${i + 1}`);
                appendOption(option);
            }
        }
    }

    $select.selectpicker('refresh');
    if (previous && $select.find(`option[value="${previous}"]`).length) {
        $select.selectpicker('val', previous);
    } else if (!$select.val() && $select.find('option').length) {
        $select.selectpicker('val', $select.find('option').first().val());
    }
    $select.selectpicker('render');

    toggleCustomerFields();
    setupCustomerCitizenship();
}

function setupCustomerCitizenship() {
    const selection = $('#customer-type').val() || '';
    if (!selection || selection.startsWith('tourist:'))
        return;

    const type = Number.parseInt(selection.split(':')[1]) || BookingCustomerType.Individual;
    if (type === BookingCustomerType.Company)
        return;

    const $citizen = $('#customer-citizen-country-id');
    if (!$citizen.length)
        return;

    const citizenVal = Number.parseInt($citizen.val() || $citizen.selectpicker('val'));
    if (!citizenVal)
        return;
    $citizen.selectpicker('render');

    let useRussianDocuments = true;
    let isRussian = false;
    const citizenshipList = window.__citizenshipList;

    if (citizenshipList) {
        const citizenship = citizenshipList.find(x => x.id == citizenVal);
        if (citizenship) {
            useRussianDocuments = useRussianDocuments && citizenship.id == window.__russiaId;
            isRussian = citizenship.id == window.__russiaId;
        }
    }

    const docTypes = getDocTypes(useRussianDocuments, isRussian, 18, 18);
    const $docSelect = $('#customer-doctype');
    const prev = Number.parseInt($docSelect.selectpicker('val') || $docSelect.val());
    $docSelect.children('option').remove();
    docTypes.forEach(dt => {
        const option = document.createElement('option');
        option.value = dt.value;
        option.text = dt.name;
        $docSelect.append(option);
    });
    $docSelect.selectpicker('refresh');
    if (docTypes.length) {
        const prevExists = docTypes.some(d => d.value == prev);
        $docSelect.selectpicker('val', prevExists ? prev : docTypes[0].value);
    }

    toggleCustomerDocumentFields();
}

function toggleCustomerDocumentFields() {
    const docType = Number.parseInt($('#customer-doctype').val());
    const showIssue = docType === TouristDocumentType.RussianPassport || docType === TouristDocumentType.RussianBirthCertificate;
    const showExp = docType === TouristDocumentType.RussianForeignPassport || docType === TouristDocumentType.ForeignDocument;

    $('.customer-doc-issue').toggleClass('hidden', !showIssue);
    $('.customer-doc-exp').toggleClass('hidden', !showExp);
}

function setColClasses($el, classes) {
    $el.removeClass(function (_, cls) {
        return (cls.match(/\bcol-(xs|sm|md|lg)-\d+\b/g) || []).join(' ');
    });
    $el.addClass(classes);
}

function applyCustomerGrid(isTourist, type) {
    setColClasses($('.customer-type-col'), 'col-md-6 col-sm-8 col-xs-12');
    setColClasses($('.customer-address-col'), 'col-md-6 col-sm-8 col-xs-12');
    setColClasses($('.customer-company-name-col'), 'col-md-6 col-sm-8 col-xs-12');
    setColClasses($('.customer-inn-company-col'), 'col-md-3 col-sm-4 col-xs-12');

    if (isTourist) {
        setColClasses($('.customer-email-col'), 'col-md-6 col-sm-6 col-xs-12');
        setColClasses($('.customer-phone-col'), 'col-md-6 col-sm-6 col-xs-12');
    } else {
        setColClasses($('.customer-email-col'), 'col-md-3 col-sm-4 col-xs-12');
        setColClasses($('.customer-phone-col'), 'col-md-3 col-sm-4 col-xs-12');
    }
}

function toggleCustomerFields() {
    const selection = $('#customer-type').val() || '';
    const isTourist = selection.startsWith('tourist:');
    const type = isTourist ? BookingCustomerType.Tourist : (Number.parseInt(selection.split(':')[1]) || BookingCustomerType.Individual);
    const showPersonal = !isTourist && (type === BookingCustomerType.Individual || type === BookingCustomerType.SoleProprietor);
    const showCompany = !isTourist && type === BookingCustomerType.Company;
    const showInnPersonal = !isTourist && type === BookingCustomerType.SoleProprietor;
    const showInnCompany = !isTourist && type === BookingCustomerType.Company;
    const showAddressField = !isTourist;
    const showContactFields = !isTourist;

    $('.customer-personal').toggleClass('hidden', !showPersonal);
    $('.customer-doc').toggleClass('hidden', !showPersonal);
    if (showPersonal)
        toggleCustomerDocumentFields();
    else {
        $('.customer-doc-issue').addClass('hidden');
        $('.customer-doc-exp').addClass('hidden');
    }
    $('.customer-inn-doc').toggleClass('hidden', !showInnPersonal);
    $('.customer-company').toggleClass('hidden', !showCompany);
    $('.customer-inn-company').toggleClass('hidden', !showInnCompany);
    $('.customer-address-field').toggleClass('hidden', !showAddressField);
    $('.customer-email-col').toggleClass('hidden', !showContactFields);
    $('.customer-phone-col').toggleClass('hidden', !showContactFields);

    applyCustomerGrid(isTourist, type);
}

function setupCustomerBlock() {
    if (!window.__cartShowCustomerBlock)
        return;

    $('#customer-type, #customer-doctype, #customer-citizen-country-id').selectpicker();
    buildCustomerTouristOptions();
    toggleCustomerFields();
    setupCustomerCitizenship();

    const dateOptions = {
        language: language,
        maxDate: new Date(),
        format: "DD.MM.YYYY",
        useCurrent: false,
        pickTime: false,
    };
    if (!$('#customer-docexpirationdate').data("DateTimePicker")) {
        const expOpts = { ...dateOptions, maxDate: undefined, minDate: new Date() };
        $("#customer-docexpirationdate").datetimepicker(expOpts);
    }
    if (!$('#customer-docdate').data("DateTimePicker")) {
        $("#customer-docdate").datetimepicker({ ...dateOptions, minDate: undefined, maxDate: new Date() });
    }
    $("#customer-docdate, #customer-docexpirationdate").mask('0Z.0Z.00ZZ', {
        translation: {
            'Z': {
                pattern: /[0-9]/,
                optional: true
            },
        },
        selectOnFocus: true,
    });
    $(".customer-doc .input-group.date").off("dp.change.customer").on("dp.change.customer", function (evt) {
        var picker = $(evt.target).data("DateTimePicker");
        if (picker)
            picker.hide();
    });

    $('#customer-type').off('changed.bs.select change').on('changed.bs.select change', () => {
        $('#customer-type').selectpicker('render');
        toggleCustomerFields();
        setupCustomerCitizenship();
        saveCartBookingInfo();
    });
    $('#customer-doctype').off('changed.bs.select').on('changed.bs.select', () => {
        toggleCustomerDocumentFields();
        saveCartBookingInfo();
    });
    $('#customer-citizen-country-id').off('changed.bs.select').on('changed.bs.select', () => {
        setupCustomerCitizenship();
        saveCartBookingInfo();
    });
    $(document).off('change blur', '#customer-details-wrapper input').on('change blur', '#customer-details-wrapper input', () => saveCartBookingInfo());
}

function normalizeRemarkText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
}

function getBookingRemarkTemplateText($row) {
    let template = $row.find('.booking-remark-template').data('template') || '';
    const values = {};
    $row.find('.booking-remark-template-value').each(function () {
        const placeholderIndex = $(this).data('placeholderIndex');
        if (placeholderIndex === undefined)
            return;

        values[placeholderIndex] = $(this).val() || '';
    });
    return normalizeRemarkText(template.replace(/\{(\d+)\}/g, function (match, placeholderIndex) {
        return values[placeholderIndex] || '';
    }));
}

function syncBookingRemarkTextarea() {
    const $container = $('#booking-add-req.booking-remark');
    if (!$container.length)
        return;

    const remarks = [];
    $container.find('.booking-remark-template:checked').each(function () {
        const text = getBookingRemarkTemplateText($(this).closest('.booking-remark-template-row'));
        if (text)
            remarks.push(text);
    });

    const customText = ($container.find('.booking-remark-custom').val() || '').trim();
    if (customText)
        remarks.push(customText);

    $container.find('textarea.add-req').val(remarks.join('\n'));
}

function setupBookingRemarkTemplates() {
    const $container = $('#booking-add-req.booking-remark');
    if (!$container.length)
        return;

    const refreshRow = function ($checkbox) {
        const $row = $checkbox.closest('.booking-remark-template-row');
        const checked = $checkbox.prop('checked');
        $row.toggleClass('active', checked);
        $row.find('.booking-remark-template-value').prop('disabled', !checked);
    };

    $container.find('.booking-remark-template').each(function () {
        refreshRow($(this));
    });

    $container
        .off('change.bookingRemark input.bookingRemark')
        .on('change.bookingRemark', '.booking-remark-template', function () {
            refreshRow($(this));
            syncBookingRemarkTextarea();
        })
        .on('click.bookingRemark mousedown.bookingRemark', '.booking-remark-template-value', function (evt) {
            evt.stopPropagation();
        })
        .on('input.bookingRemark change.bookingRemark', '.booking-remark-template-value, .booking-remark-custom', function () {
            syncBookingRemarkTextarea();
        });

    syncBookingRemarkTextarea();
}

function setupCartDynamicBlocks() {
    setupCustomerBlock();
}

function getBookingAdditionalRequirements() {
    if ($('#booking-add-req.booking-remark').length) {
        syncBookingRemarkTextarea();
        return $('#booking-add-req textarea.add-req').val();
    }

    return $("#booking-add-req textarea.add-req").val();
}

function getServiceTouristForms(serviceId) {
    const $legacyForms = $("#moreInfo" + serviceId + " .arrived-info form");
    if ($legacyForms.length)
        return $legacyForms;

    return $('.arrived-info[data-service-id="' + serviceId + '"] form');
}


// Возвращает данные о брони в виде объекта
function getCartBookingInfo() {
    var booking = {
        services: [],
        anonymousContactEmail: $('input[name="contact-email"]').val(),
        anonymousContactPhone: $('input[name="contact-phone"]').val(),
        additionalRequirements: getBookingAdditionalRequirements(),
        prepayment: Number.parseFloat($('#totalBookingSum').data('prepayment')),
        prepaymentRequired: $('#totalBookingSum').data('prepayment-required') != undefined,
        payment: Number.parseFloat($('#totalBookingSum').data('payment')),
        policy: $('#policy').prop('checked'),
        offer: $('#offer').prop('checked'),
        healthDeclarationChecked: $('#health-declaration').prop('checked'),
    };

    const selection = $('#customer-type').val() || '';
    const isTouristCustomer = selection.startsWith('tourist:');
    const parsedType = Number.parseInt(selection.split(':')[1]);
    const customerType = isTouristCustomer ? BookingCustomerType.Tourist : (isNaN(parsedType) ? BookingCustomerType.Individual : parsedType);
    const customer = {
        type: customerType,
        touristKey: isTouristCustomer ? selection.substring('tourist:'.length) : null,
        email: $('#customer-email').val(),
        phone: $('#customer-phone').val(),
    };

    if (!isTouristCustomer) {
        if (customerType === BookingCustomerType.Company) {
            customer.name = $('#customer-company-name').val();
            customer.inn = $('#customer-inn-company').val();
        } else {
            customer.surname = $('#customer-surname').val();
            customer.name = $('#customer-name').val();
            customer.middlename = $('#customer-middlename').val();
            const docType = Number.parseInt($('#customer-doctype').val()) || null;
            customer.doctype = docType;
            customer.docnumber = $('#customer-docnumber').val();
            const showIssue = docType === TouristDocumentType.RussianPassport || docType === TouristDocumentType.RussianBirthCertificate;
            const showExp = docType === TouristDocumentType.RussianForeignPassport || docType === TouristDocumentType.ForeignDocument;
            customer.docdate = showIssue ? toJsonDate($('#customer-docdate')) : null;
            customer.docexpirationdate = showExp ? toJsonDate($('#customer-docexpirationdate')) : null;
            customer.citizenCountryId = Number.parseInt($('#customer-citizen-country-id').val()) || null;
            if (customerType === BookingCustomerType.SoleProprietor)
                customer.inn = $('#customer-inn').val();
        }
        customer.address = $('#customer-address').val();
    }

    booking.customer = customer;
    $("tr.order-info.service").each(function (idx, elt) {
        elt = $(elt);
        var serviceId = elt.attr("data-service-id");
        var service = { id: serviceId, tourists: [] };
        getServiceTouristForms(serviceId).each(function (idx1, eltT) {
            eltT = $(eltT);
            var tourist = eltT.serializeObject();
            tourist.birthdate = toJsonDate(eltT.find(".birthdate input"));
            tourist.docexpirationdate = toJsonDate(eltT.find(".docexpirationdate input"));
            tourist.docdate = toJsonDate(eltT.find(".docdate input"));
            service.tourists.push(tourist);
        });
        // service.additionalRequirements = $("#dopInfo" + serviceId + " textarea.add-req").val();
        // Поля трансферов
        if ($("#dopInfo" + serviceId + ".transfer").length) {
            service.flightCity = $("#flightCity" + serviceId).val();
            service.flightNo = $("#flightNo" + serviceId).val();
            var fth = $("#flightTime" + serviceId).val();
            if (fth)
                service.flightTime = fth + ":" + $("#flightTimeMin" + serviceId).val();
            var tth = $("#tranTime" + serviceId).val();
            if (tth)
                service.transferTime = tth + ":" + $("#tranTimeMin" + serviceId).val();
        }
        // Место встречи экскурсии
        if ($("#dopInfo" + serviceId + ".excursion").length) {
            service.pickupPointId = Number.parseInt($("[name=pickupPoint" + serviceId + "]:checked").val()) || null;
            //service.pickupPoint = $("#pickupPoint" + serviceId).val();
        }
        booking.services.push(service);
    });
    return booking;
}


// Сохраняет данные пользователя
function saveCartBookingInfoAfterBirthDateChange(input) {
    const identity = getBirthDateChangeIdentity(input);
    if (!identity) {
        saveCartBookingInfo();
        return;
    }

    clearBirthDateMessage(input);
    const booking = getCartBookingInfo();
    if (!booking.services.length)
        return;

    ajaxPost(
        appBase + "Cart/ValidateTouristBirthDate",
        {
            bookingJson: JSON.stringify(booking),
            serviceId: identity.serviceId,
            touristIdx: identity.touristIdx,
        },
        function (response) {
            if (response?.hasErrors) {
                showCartBookingErrors(response, true);
                return;
            }

            saveCartBookingInfo({ changedBirthDate: identity });
        },
        "json", true
    );
}

function saveCartBookingInfo(options = {}) {
    var booking = getCartBookingInfo();
    if (!booking.services.length)
        return;
    ajaxPost(
        appBase + "Cart/SaveCartBookingInfo", { bookingJson: JSON.stringify(booking) },
        function (response) {
            showOrderPriceChangedNotification(response);
            var newVersion = response.compulsoryServicesVersion || null;
            var prevVersion = $('#compulsory-services-table').attr('data-version') || null;
            const showBirthDateMessage = hasCostDifference(response) && options.changedBirthDate;
            const afterRender = function () {
                if (showBirthDateMessage)
                    setBirthDateMessage(options.changedBirthDate, insurancePriceChangedMessage);
            };
            if (newVersion !== prevVersion || response?.priceChanged) {
                ajaxPost(appBase + "Cart/ReRenderCart", {}, function (html) {
                    mergeControls(html);
                    setupCartDynamicBlocks();
                    afterRender();
                });
            } else {
                afterRender();
            }
        },
        "json", true
    );
}


// Бронирование
function cartMakeBooking(paymentParams) {
    $(".arrived-info *,.transfer *,.excursion *,.contact-details *,#policies-container *").removeClass("error");
    const booking = getCartBookingInfo();
    if (!booking.services.length)
        return;

    //if (!await validateCart(booking))
    //    return;

    validateCart(booking, () => {
        let payEnabled = !!Window.payEnabled;
        if (payEnabled) {
            const root = PaymentFormContainer({
                allowPayingLater: booking.prepayment == 0 || !booking.prepaymentRequired,
                allowPartialPayment: booking.prepayment < booking.payment,
                agentAcquiringPercentByCard: window.__agentAcquiringPercentByCard,
                agentAcquiringPercentBySbp: window.__agentAcquiringPercentBySbp,
                agentAcquiringPercentBySbpLegal: window.__agentAcquiringPercentBySbpLegal,
                userType: window.__userIsAgent ? 'agent' : 'personal',
                prepaymentAmount: booking.prepayment,
                paymentAmount: booking.payment,
                onSuccess: (p) => {
                    validateCart(booking, () => continueBooking(p, booking), (r) => {
                        showCartBookingErrors(r);
                        $('#payment-ui').modal('hide');
                        setTimeout(function () {
                            unmountComponentAtNode(document.getElementById('payment-ui-container'));
                        }, 160);
                    });
                },
                onCancel: () => {
                    $('#payment-ui').modal('hide');
                    setTimeout(function () {
                        unmountComponentAtNode(document.getElementById('payment-ui-container'));
                    }, 160);
                },
                onInitialized: () => $('#payment-ui').modal(),
                currencyName: $('#totalBookingSum').data('currency'),
                location: 'CartOnly',
            });
            render(root, document.getElementById('payment-ui-container'));
        }
        else {
            continueBooking(paymentParams, booking);
        }
    }, (r) => showCartBookingErrors(r));
}

const continueBooking = async (paymentParams, booking) => {
    const apiResponse = await api('post', '/Cart/MakeBooking', {
        bookingJson: JSON.stringify({
            ...booking,
            paymentSystem: paymentParams?.paymentSystem,
            paymentMethod: paymentParams?.paymentMethod,
            paymentAmount: paymentParams?.paymentAmount,
        })
    });

    let res = apiResponse.response;
    console.log(res);
    if (res.paymentUrl) {
        openPaymentUrl(res.paymentUrl);
    }
    else
        if (res.progressUrl) {
            window.location.replace(res.progressUrl);
        }
        else
            res = res.response;

    if (res.redirectUrl)
        window.location.replace(res.redirectUrl);
    else if (res.hasErrors)
        showCartBookingErrors(res);
    else {
        $("#mainPageContent").html(res);
        if (!booking.prepayment)
            $('#global-cart-count').remove();
        $(document).on("click", ".do-payment", function (evt) {
            const amount = $('#pay-type-form').prop('pay-amount')?.value ?? $(evt.target).attr("data-amount");
            if (amount > 0)
                pay($(evt.target).attr("data-id"), amount);
            else
                location = $(evt.target).attr("data-booking-url") ?? "/";
        });
        $(document).on("change", "#prepay-input", prepayAmountChanged);
        $(document).on("blur", "#prepay-input", prepayAmountChanged);
        $(document).on("click", "#prepay-edit-button", function (ent) {
            $('#prepay-input').show();
            $('#prepay-edit-button').hide();
            $('#prepay-text').hide();
        });
    }
}

const validateCart = async (booking, onValid, onInvalid) => {
    const apiResponse = await api('post', '/Cart/Validate', {
        bookingJson: JSON.stringify({
            ...booking
        })
    });

    const res = apiResponse.response;
    console.log(res);
    if (res.hasErrors && onInvalid)
        onInvalid(res);
    else if (!res.hasErrors && onValid)
        onValid(res);
    //showCartBookingErrors(res);

    return !res.hasErrors;
}


// Отображает ошибки бронирования
function showCartBookingErrors(res, onlyField = false) {
    // Выделение туристов и строк с ошибками
    if (res.serviceErrors && res.serviceErrors.length) {
        for (var i = 0; i < res.serviceErrors.length; i++) {
            var error = res.serviceErrors[i];
            var touristRows = $(".service" + error.serviceId + " .row.tourist");
            if (error.serviceId < 0) {
                $('.cart .' + error.field).addClass('error');
                continue;
            }
            // Выделение туристов
            if (typeof error.touristIdx == "number" && touristRows.length > error.touristIdx) {
                const $touristRow = $(touristRows[error.touristIdx]);
                $touristRow.addClass("error");
                console.log(error.field);
                if (error.field) {
                    const fieldClass = getLegacyFieldClassName(error.field);
                    const $field = $touristRow.find("." + fieldClass).first();
                    $field.addClass("error");
                    if (onlyField && res.genericError)
                        setFieldMessage($field.closest('.form-group').length ? $field.closest('.form-group') : $field, res.genericError);
                }
            }
            // Выделение услуги
            if (typeof error.touristIdx != "number" && error.field)
                $(".service" + error.serviceId + " ." + getLegacyFieldClassName(error.field)).addClass("error");
        }

        if (!onlyField) {
            $(".row.tourist.error,.transfer .error,.excursion .error").closest(".arrived,.simple-arrived").each(function (idx, elt) {
                $(elt).collapse("show");
            });
            var topError = $(".error");
            if (topError.length)
                $("html, body").animate({ scrollTop: topError.offset().top });
        }
    }
    // Отображение окна с ошибкой
    if (res.genericError && !onlyField) {
        let message = res.genericError;
        if (res.searchRequest)
            try {
                let url = appUrl('/Tour', { ...res.searchRequest, autoReplace: 1 });
                message = formatString(message, [url]);
            }
            catch { }

        if (res.action == 'OpenFlightModal') {
            const event = new CustomEvent('openFlightModalRequested', {
                cancelable: true,
                detail: { ...e.detail }
            });
            document.dispatchEvent(event);
        }
        else {
            const hider = document.getElementById('content-hider');
            if (hider)
                hider.style.display = "none";

            showErrorDialog(message, null, true);
        }
    }
}

function prepayAmountChanged(e) {
    var min = Number.parseFloat($('#prepay-input').prop('min'));
    var max = Number.parseFloat($('#prepay-input').prop('max'));
    var initValue = Number.parseFloat($('#prepay-input').val());
    var newValue = initValue;
    if (newValue < min)
        newValue = min;
    if (newValue > max)
        newValue = max;
    var formated = new Intl.NumberFormat(language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(newValue);
    $('#prepay-amount').val(newValue);
    $('#prepay-text').text(formated);
    if (initValue != newValue)
        $('#prepay-input').val(newValue);
    $('#prepay-input').hide();
    $('#prepay-edit-button').show();
    $('#prepay-text').show();
}

function pay(id, amount = null) {
    ajaxGet(
        appBase + "PrivateOffice/DoPayment",
        { id, amount },
        function (res) {
            if (res.TargetUrl) {
                if (!res.PostData) {
                    location = res.TargetUrl;
                } else {
                    submitForm(res.TargetUrl, res.PostData);
                }
            }
            else {
                $('body').append();
            }
        }
    );
}


/**
 * @typedef TourState
 *
 * @property {import('../TourSearch/store/TourDescriptionStoreContainer').InitialState} initialState
 * @property {string} hash
 * @property {boolean} cartShowTourExtrasBlock
 */

/**
 * 
 * @param {TourState} tourState
 */
function mounTourConfiguratorContainer(tourState, tourPriceExpired) {
    const container = document.getElementById('tour-configurator-container');
    unmountComponentAtNode(container);
    const root = CartTourConfiguratorContainer({ tourPriceExpired, initialState: tourState?.initialState, onFlightSelect: onFlightSelect, onExtrasChange: onExtrasChange, cartShowTourExtrasBlock: tourState?.cartShowTourExtrasBlock || false });
    render(root, container);
}

/**
 * 
 * @param {import('../../include/api-ito/common-types/FlightVariants').FlightPriceViewModel | undefined} f
 * @param {Record<string, number[] | undefined>} extras
 * @param {import('../NewTourSearch/types/Price').Price} tourPrice
 * @param {() => void} callback
 */
function onFlightSelect(f, separatedFlights, extras, tourPrice, excursions, callback) {
    updateTour({
        tourVariantId: tourPrice.tourVariantId,
        excursions: excursions,
        hash: tourPrice.servicesHash,
        flightId: f?.flightId,
        flightProviderId: f?.providerId,
        separatedFlights,
        extras: mapExtrasToJsonCompatibility(extras),
    }, callback);
}

/**
 * 
 * @param {Record<string, number[] | undefined>} extras
 * @param {import('../NewTourSearch/types/Price').Price} tourPrice
 * @param {() => void} callback
 */
function onExtrasChange(extras, tourPrice, excursions, flightId, flightProviderId, separatedFlights, callback) {
    updateTour({
        tourVariantId: tourPrice.tourVariantId,
        excursions: excursions,
        hash: tourPrice.servicesHash,
        flightId,
        flightProviderId,
        extras: mapExtrasToJsonCompatibility(extras),
        separatedFlights,
    }, callback);
}

function updateTour(data, callback) {
    const csrf = readCsrfToken();
    fetch(appUrl('/Cart/UpdateTour'), {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'text/html',
            'X-XSRF-TOKEN': csrf
        },
        body: JSON.stringify(data),
    })
        .then(r => {
            showTourUpdatePriceChangedNotification(r);
            return r.text();
        })
        .then(html => {
            //document.getElementsByClassName('container-full')[0].removeAttribute('aria-hidden');

            //setTimeout(() => {
            //}, 100);

            mergeControls(html);
            setupCartDynamicBlocks();

            $("a.change-tour").attr("data-tour-flight-id", data.flightId);
            $("a.change-tour").attr("data-tour-flight-provider-id", data.flightProviderId);
            $("a.change-tour").attr("data-tour-separated-flights", JSON.stringify(data.separatedFlights || []));

            $('#healthCheckUrl').off('mouseup');
            $('#healthCheckUrl').on('mouseup', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                $('#healthDeclarationDialog').modal();
            });

            if (callback)
                setTimeout(callback, 500);
        })
}

export {
    setupLayout,
    setupCart,
    setupCart2,
    setupCartExtended,
    pay,
    setupBookingSuccess
};
